import Rtq from "../RTQ";

export default Rtq;
